export default "__VITE_ASSET__U2QNLfHr__"